import { render, staticRenderFns } from "./zhuanhuan.vue?vue&type=template&id=df595240&scoped=true&"
import script from "./zhuanhuan.vue?vue&type=script&lang=js&"
export * from "./zhuanhuan.vue?vue&type=script&lang=js&"
import style0 from "./zhuanhuan.vue?vue&type=style&index=0&id=df595240&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df595240",
  null
  
)

export default component.exports